export default __webpack_public_path__ + "static/media/token.09a58bed.svg";